 jQuery(function () {
      const VIP_PRICE = 400;
      const REG_PRICE = 150;

      const $container = jQuery('#ticketApp');

      // Create elements
      const $vipLabel = jQuery('<label>').text(`RAN FAN VIP Package ($${VIP_PRICE} each): `);
      const $vipSelect = jQuery('<select id="vipTickets"></select>');

      const $regLabel = jQuery('<label>').text(`General Tickets ($${REG_PRICE} each): `);
      const $regSelect = jQuery('<select id="regularTickets"></select>');

      const $donationLabel = jQuery('<label>').text(`Additional Donation (USD Dollar Amount): `);
      const $donationInput = jQuery('<input type="number" id="donation" min="0" step="1">');

      const $totalText = jQuery('<strong>').html(`Your Total: $<span id="total">0</span>`);

      // Populate dropdowns
      for (let i = 0; i <= 10; i++) {
        $vipSelect.append(jQuery('<option>', { value: i, text: i }));
        $regSelect.append(jQuery('<option>', { value: i, text: i }));
      }

      // Update total function
      function updateTotal() {
        const vipCount = parseInt($vipSelect.val(), 10) || 0;
        const regCount = parseInt($regSelect.val(), 10) || 0;
        const donation = parseFloat($donationInput.val()) || 0;

        const total = (vipCount * VIP_PRICE) + (regCount * REG_PRICE) + donation;
        const formattedtotal = total.toFixed(2);
        jQuery('#total').text(formattedtotal);
        jQuery('#reveldonate').attr("href", "https://act.ran.org/page/86746/donate/1?ea.tracking.id=w_ran&en_og_source=w_ran&transaction.donationAmt="+formattedtotal+"&supporter.NOT_TAGGED_54="+vipCount+","+regCount+","+donation);
      }

      // Event listeners
      $vipSelect.on('change', updateTotal);
      $regSelect.on('change', updateTotal);
      $donationInput.on('input', updateTotal);

      // Build layout
      $container.append('Join us for an exclusive VIP reception & the musical event<br>');
      $container.append($vipLabel, $vipSelect, '<br>');
      $container.append($regLabel, $regSelect, '<br><br>');
      $container.append($donationLabel, $donationInput, '<br><br>');
      $container.append($totalText);
      $container.append('<br><br><a id="reveldonate" href="">Next Step &rarr;</a>');

    });